module.exports = __webpack_public_path__ + "models/router_fd05bb753db3705484a19eb5b3efcfed.glb";